<div class="content-block">

    <!-- Content Header (Page header) -->
    
   <!-- <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Dipendenti</h1>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home" title="Dashboard">Dashboard</a></li>
               <li class="breadcrumb-item"><a href="/dipendenti" title="Elenco dipendenti">Dipendenti</a></li>
             </ol>
           </div>
         </div>
       </div>
     </div>
    --> 


            <div class="row">
              <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                      <h2 class="content-block">Nuovo dipendente</h2>
                      <div class="d-flex gap-4" >
                       
                      </div>
                  </div>
              </div>
            </div>
  





  <div class="card primary">
    <!--<div class="card-header">
      <h3 class="card-title">
        <i class="fa fa-chart-pie mr-1"></i>
        Nuovo dipendente 
      </h3>
      <div class="col-lg-6 col-12">
        

      </div>
      
    </div>--><!-- /.card-header -->
    <div class="card-body">
        <app-form-dipendente  [idDipendente]="0"></app-form-dipendente>
      </div><!-- /.card-body -->
      
    </div>
    <!-- /.card -->


</div>

